const API_BASE = process.env.REACT_APP_API_URL || '';

export function careerMediaUrl(url) {
    return url?.startsWith('/') ? `${API_BASE.replace(/\/$/, '')}${url}` : url;
}

async function request(path, body, multipart = false) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), multipart ? 150000 : 30000);
    try {
        const response = await fetch(`${API_BASE}/web/careers/${path}`, {
            method: 'POST', signal: controller.signal,
            headers: multipart ? undefined : { 'Content-Type': 'application/json' },
            body: multipart ? body : JSON.stringify(body),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
            const validation = data.errors?.map(e => `${e.loc?.slice(1).join(' ')}: ${e.msg}`).join('; ');
            throw new Error(validation || data.detail || 'Something went wrong. Please try again.');
        }
        return data;
    } catch (error) {
        if (error.name === 'AbortError') throw new Error('The request timed out. Please try again.');
        throw error;
    } finally { clearTimeout(timer); }
}

export const submitCareerApplication = (body) => request('applications', body);
export const previewCareerVideo = (url) => request('video-preview', { url });
export function uploadCareerVideo(file) {
    const body = new FormData();
    body.append('file', file);
    return request('videos', body, true);
}
